const roles = {
  Client: "Client",
  Staff: "Staff",
  Admin: "Admin",
};

// Admins can do everything. Staff can look at the operational side of the
// business but change nothing, and cannot see revenue. Clients only ever see
// their own account.
export const adminOnly = [roles.Admin];
export const internalUsers = [roles.Admin, roles.Staff];
export const everyone = [roles.Admin, roles.Staff, roles.Client];

export const isAdmin = (role) => role === roles.Admin;
export const isStaffMember = (role) => internalUsers.includes(role);
export const isClient = (role) => role === roles.Client;

export default roles;
